var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { OverflowTooltip } from '../OverflowTooltip';
const Toolbar = styled(Box) `
    width: 100%;
    padding: 0 7px;
    height: 44px;
    background: ${({ theme }) => (theme.palette.mode === 'light' ? grey[100] : grey[900])};
    border-bottom: 1px solid ${({ theme }) => (theme.palette.mode === 'light' ? grey[400] : grey[600])};
    display: flex;
    align-items: center;

    & .MuiTabs-indicator {
        height: 2px;
        bottom: 2px;
    }

    & .MuiTab-root {
        padding: 0;
        margin-right: 16px;
        text-transform: none;
        font-size: 14px;
        min-width: auto;
        max-width: 240px;
        align-items: flex-start;
        &:last-child {
            margin-right: 0;
        }

        &.Mui-selected {
            font-weight: 800;
        }
    }
`;
const LogoWrapper = styled('div') `
    width: 32px;
    height: 32px;
    border-radius: 2px;
    margin-right: 12px;
`;
const AppName = styled(Typography) `
    font-weight: 700;
    font-size: 18px;
    margin-right: 30px;
    max-width: 240px;
`;
export const AppToolbar = (props) => {
    const { logo, name, children } = props, other = __rest(props, ["logo", "name", "children"]);
    return (_jsxs(Toolbar, Object.assign({}, other, { children: [logo && _jsx(LogoWrapper, { children: logo }), typeof name === 'string' ? (_jsx(AppName, { variant: 'subtitle1', component: 'h1', children: _jsx(OverflowTooltip, { children: name }) })) : (name), children] })));
};
